import { render, staticRenderFns } from "./EliminationMatchInfo.vue?vue&type=template&id=f94a8b18&scoped=true&"
import script from "./EliminationMatchInfo.vue?vue&type=script&lang=js&"
export * from "./EliminationMatchInfo.vue?vue&type=script&lang=js&"
import style0 from "./EliminationMatchInfo.vue?vue&type=style&index=0&id=f94a8b18&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f94a8b18",
  null
  
)

component.options.__file = "EliminationMatchInfo.vue"
export default component.exports